import { connect } from 'react-redux';
import uploadXMLButton from '../components/upload-xml-button';
import {
  uploadFileRequest,
  createXMLRequest,
  setSelectedEquipment,
  uploadActionRequest,
} from './upload-xml-actions';
import { deleteAllDraftsRequest } from '../../../drafts/containers/draft-actions';

const mapDispatchToProps = {
  uploadFileRequest,
  createXMLRequest,
  setSelectedEquipment,
  deleteDrafts: deleteAllDraftsRequest,
  uploadAction: uploadActionRequest,
};

const mapStateToProps = state => ({
  id: state.uploadXML.id,
  redirectUri: state.uploadXML.redirectUri,
  isLoading: state.uploadXML.isLoading,
  isCreating: state.uploadXML.isCreating,
  error: state.uploadXML.error,
  createXMLFailed: state.uploadXML.createXMLFailed,
  userName: state.user.fullname,
  selectedEquipment: state.uploadXML.selectedEquipment,
  customerCenter: state.serviceCenter.activeServiceCenter,
  createXMLSuccess: state.uploadXML.createXMLSuccess,
  needsMoreData: state.uploadXML.needsMoreData,
  requestedData: state.uploadXML.requestedData,
  serviceCenters: state.user.serviceCenters,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(uploadXMLButton);
